export default __webpack_public_path__ + "4a6a215790a0342c06420957156842db.woff2";